// Per-visitor memory for the featured offer card, kept in this browser only
// (localStorage, nothing sent anywhere). Every access is wrapped because
// storage can be blocked or throw in private windows.

const KEY = "mr_offers_v1";
const HIDE_MS = 30 * 24 * 60 * 60 * 1000;
export const MAX_VIEWS_PER_WEEK = 3;

export type OfferStore = {
  week: string;
  seen: Record<string, number>;
  hidden: Record<string, number>;
  played: string[];
};

function isoWeek(d = new Date()): string {
  const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const day = t.getUTCDay() || 7;
  t.setUTCDate(t.getUTCDate() + 4 - day);
  const y0 = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
  return `${t.getUTCFullYear()}-W${Math.ceil(((t.getTime() - y0.getTime()) / 86400000 + 1) / 7)}`;
}

export function loadStore(): OfferStore {
  const fresh: OfferStore = { week: isoWeek(), seen: {}, hidden: {}, played: [] };
  try {
    const s = JSON.parse(localStorage.getItem(KEY) ?? "null") as OfferStore | null;
    if (!s) return fresh;
    // View counts reset every week; hides and visited games carry over.
    if (s.week !== fresh.week) return { ...fresh, hidden: s.hidden ?? {}, played: s.played ?? [] };
    return { ...fresh, ...s };
  } catch {
    return fresh;
  }
}

export function saveStore(s: OfferStore) {
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    /* storage unavailable: the card still works, it just won't remember */
  }
}

export function isHidden(s: OfferStore, key: string): boolean {
  const at = s.hidden[key];
  return !!at && Date.now() - at < HIDE_MS;
}

export function rememberPlayed(slug: string) {
  const s = loadStore();
  if (s.played.includes(slug)) return;
  s.played = [slug, ...s.played].slice(0, 60);
  saveStore(s);
}
